import { Button } from "../ui";
import { postToHost } from "../lib/postmessage";
import { ctaTranslateText } from "../lib/ctaTranslate";
import { useLabel } from "../lib/labels";
import type { ConfirmationData } from "../types";

interface Props {
  data: ConfirmationData;
  sessionToken: string;
}

export default function ConfirmationCard({ data, sessionToken }: Props) {
  const actionLabel = useLabel("action", "Action");
  // confirm_gate 폐기: Yes → tool_directive (toolCall) 전송.
  // confirmation_router → exec_tools 직행 (LLM 0회).
  const sendYes = () =>
    postToHost(
      "chat.send_prompt",
      {
        message: data.yesMessage || "yes proceed",
        toolCall: { tool: data.tool, args: data.args || data.argsPretty },
      },
      { sessionId: sessionToken }
    );
  // cancel 은 Case A — 위젯 클릭 시점에 카탈로그 변환.
  const sendCancel = async () => {
    const message = await ctaTranslateText({
      code: "confirm.cancel_that",
      sessionToken,
      fallback: "cancel that",
    });
    postToHost(
      "chat.send_prompt",
      { message },
      { sessionId: sessionToken }
    );
  };

  return (
    <div className="ac-confirm">
      <header className="ac-confirm__head">
        <h2 className="ac-confirm__title">{data.title}</h2>
        <p className="ac-confirm__prompt">{data.prompt}</p>
      </header>

      {Object.keys(data.argsPretty || {}).length > 0 && (
        <div className="ac-confirm__args">
          <p className="ac-confirm__args-label">{actionLabel}</p>
          <p className="ac-confirm__args-tool">{data.tool}</p>
          <pre className="ac-confirm__args-json">
            {JSON.stringify(data.argsPretty, null, 2)}
          </pre>
        </div>
      )}

      <div className="ac-confirm__actions">
        <Button variant="secondary" size="xs" onClick={sendCancel}>
          {data.cancelLabel}
        </Button>
        <Button variant="primary" size="xs" onClick={sendYes}>
          {data.yesLabel}
        </Button>
      </div>
    </div>
  );
}
